/**
 * What a workflow run is waiting on before it starts. A run stays `queued`
 * through every one of these; the run's stream carries the current one as a
 * `status` event (`{ status: 'preparing', phase, message }`) and the run
 * detail's `sandboxV2Sandbox.stage` carries the copy's persisted claim stage.
 */

/** The claim stages a Sandboxes v2 copy persists (`sandbox_v2_sandboxes.stage`). */
export const SANDBOX_V2_COPY_STAGES = [
  'waiting_for_snapshot',
  'waiting_for_capacity',
  'restoring_copy',
  'preparing_copy',
] as const;

export type SandboxV2CopyStage = (typeof SANDBOX_V2_COPY_STAGES)[number];

export type RunPrestartPhase = SandboxV2CopyStage | 'waking_app' | 'signing_in';

export const RUN_PRESTART_MESSAGES: Record<RunPrestartPhase, string> = {
  waiting_for_snapshot: 'Building the sandbox snapshot for this commit…',
  waiting_for_capacity: 'Waiting for sandbox capacity…',
  restoring_copy: 'Restoring a sandbox copy…',
  preparing_copy: 'Preparing the sandbox copy…',
  waking_app: 'Waiting for the app to start…',
  signing_in: 'Signing in…',
};
